import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';

class Audio extends React.PureComponent {
    static propTypes = {
        audioinfo: PropTypes.object,
    };

    state = {
        isPlay: false,
        progresWidth: 0,
        timeLen: this.props.audioinfo.duration,
    };

    audio = React.createRef();

    componentDidMount() {
        const audioDom = this.audio.current;
        const { audioinfo } = this.props;
        const timeLenPro = audioinfo.duration;

        this.unUpdate = addEventListener(audioDom, 'timeupdate', () => {
            this.setState({
                progresWidth: `${this.timePercentage(audioDom.currentTime)}%`,
                timeLen: timeLenPro - Math.floor(audioDom.currentTime),
            });
        });

        this.unEnded = addEventListener(audioDom, 'ended', () => {
            this.endTimer = setTimeout(() => {
                this.setState({
                    isPlay: false,
                    timeLen: timeLenPro,
                    progresWidth: 0,
                });
            }, 1000);
        });
    }

    componentWillUnmount() {
        this.unUpdate();
        this.unEnded();
        clearTimeout(this.endTimer);
    }

    timePercentage = currentTime => {
        const {
            audioinfo: { duration },
        } = this.props;

        return Math.floor((Math.floor(currentTime) / duration) * 100) || 1;
    };

    timeFormatFn = () => {
        const { timeLen } = this.state;
        const timeNum = timeLen;
        const min = Math.floor(timeNum / 60) < 10 ? `0${Math.floor(timeNum / 60)}` : Math.floor(timeNum / 60);
        const sec = timeNum % 60 < 10 ? `0${timeNum % 60}` : timeNum % 60;

        return `${min}:${sec}`;
    };

    handleAudioPlay = () => {
        this.setState({
            isPlay: true,
        });

        this.audio.current.play();
    };

    handleAudioPause = () => {
        this.setState({
            isPlay: false,
        });

        this.audio.current.pause();
    };

    render() {
        const {
            audioinfo: { title, playUrl },
        } = this.props;
        const { isPlay, progresWidth } = this.state;

        return (
            <div className={styles.audioBox}>
                <div className={styles.box}>
                    {isPlay ? (
                        <span className={styles.pauseIcon} onClick={this.handleAudioPause} />
                    ) : (
                        <span className={styles.playIcon} onClick={this.handleAudioPlay} />
                    )}
                    <span className={styles.title}>{title}</span>
                    <span className={styles.time}>{this.timeFormatFn()}</span>
                </div>
                <audio ref={this.audio} className={styles.audio} preload="none">
                    <source src={playUrl} />
                </audio>
                <div
                    className={styles.progresBar}
                    style={{
                        width: progresWidth,
                    }}
                />
            </div>
        );
    }
}

export default errorBoundary(Audio);
